

























import { Component, Vue } from "vue-property-decorator";
import { Toast, Field, Tag } from 'vant';
import { AreaInfo, defaultCity } from '@/data/local/common'
import { getQueryParam } from "@/utils/index";
import { ErrorCode, ErrorInfo } from "@/network/http";
import { formatMessage } from "@/locale";
import CitySelector from "@/components/CitySelector.vue";


Vue.use(Toast);
Vue.use(Field);
Vue.use(Tag);

@Component({
    components: {
        "v-city-selector": CitySelector
    }
})
export default class CreateTopic extends Vue {
    cityId: number = 0;
    type: number = 0;

    city: AreaInfo = defaultCity;

    selectedColor: string = "#f2826a";
    unselectColor: string = "#999999";

    bizTypeColumns: any = ['贷款业务', '提取业务', '缴存业务', '其他业务'];
    bizContent: string = "";
    email: string = "";
    
    
    mounted() {
        let cityId: number = parseInt(this.$route.params.cityId);
        let type: number = parseInt(this.$route.params.type);
        this.cityId = cityId;
        this.type = type;

        if (type <= 0 || type > 5) {
            this.type = 1;
        }
    }

    onSelectCity(city: AreaInfo) {
        this.city = city;
    }

    changeBizType(type: number) {
        this.type = type;
    }

    onSubmit() {
        if (!this.type || !this.bizContent) {
            Toast("请输入内容！");
            return;
        }

        if (this.email) {
            //检查邮箱格式
            var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!regEmail.test(this.email)){
                Toast("请输入有效的邮箱！");
                return;
            }
        }

        let lThis:any = this;
        lThis.$http.createTopic(this.cityId, 1, this.type, this.email, this.bizContent, (errorInfo: ErrorInfo) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                Toast(errorInfo.msg);
            } else {
                Toast("提交成功！");
                this.$router.go(-1);
            }
        });
    }
}
